window.addEventListener('SITE_START', () => {
  const tab = document.querySelector('[data-tabset]');
  if (!tab) return;

  const tabs = tab.querySelectorAll('[data-tab]');
  const contents = document.querySelectorAll('[data-content]');
  const activeClass = tab.dataset.tabset || '--active';

  tabs.forEach(tab => {
    tab.addEventListener('click', e => {
      e.preventDefault();

      // 활성 탭 변경
      tabs.forEach(t => t.classList.remove(activeClass));
      tab.classList.add(activeClass);

      // 일치하는 컨텐츠 노출
      const target = tab.dataset.tab;
      contents.forEach(c => {
        c.style.display = c.dataset.content === target ? '' : 'none';
      });
    });
  });
});